import { Component, Input } from '@angular/core';

@Component({ selector: 'app-central-skeleton', templateUrl: './central-skeleton.component.html',
    styleUrls: ['./central-skeleton.component.scss'] })
export class CentralSkeletonComponent {
    @Input() page: 'dashboard' | 'teams' | 'streakers' | 'friends' | 'members' | 'standings' | 'stats' = 'dashboard';
    get compact(): boolean { return ['friends', 'members', 'standings', 'stats'].includes(this.page); }
    readonly cards = [0, 1, 2, 3, 4, 5];
}
